import { inject, Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { publish } from 'rxjs';

interface IconPaths {
    [key: string]: string;
}

@Injectable({ providedIn: "root" })
export class IconService {
    private iconPaths: IconPaths = {
        search: "assets/icons/search.svg",
        wishlist: "assets/icons/wishlist.svg",
        cart: "assets/icons/cart.svg",
        user: "assets/icons/user.svg",
        box_user: "assets/icons/box_user.svg",
        keyboard_arrow_down: "assets/icons/keyboard_arrow_down.svg",
        home: "assets/icons/home.svg",
        briefcase: "assets/icons/briefcase.svg",
        location: "assets/icons/location.svg",
        right_arrow_alt: "assets/icons/right_arrow_alt.svg",
        check: "assets/icons/check.svg",
        shield_half: "assets/icons/shield_half.svg",
        notification: "assets/icons/notification.svg",
        order: "assets/icons/order.svg",
        contact: "assets/icons/contact.svg",
        logout: "assets/icons/logout.svg",
        backarrow: "assets/icons/backarrow.svg",
        forwardarrow: "assets/icons/forwardarrow.svg",
        giftbox: "assets/icons/giftbox.svg",
        tag: "assets/icons/tag.svg",
        delivery: "assets/icons/delivery.svg",
        newarrival: "assets/icons/newarrival.svg",
        fullstar: "assets/icons/fullstar.svg",
        halfstar: "assets/icons/halfstar.svg",
        rightarrow: "assets/icons/rightarrow.svg",
        plus: "assets/icons/plus.svg",
        minus: "assets/icons/minus.svg",
        activewishlist: "assets/icons/activewishlist.svg",
        age: "assets/icons/age.svg",
        safematerial: "assets/icons/safematerial.svg",
        bulb: "assets/icons/bulb.svg",
        color: "assets/icons/color.svg",
        tick: "assets/icons/tick.svg",
        ig: "assets/icons/ig.svg",
        fb: "assets/icons/fb.svg",
        utube: "assets/icons/utube.svg",
        pin: "assets/icons/pin.svg",
        paypal: "assets/icons/paypal.svg",
        visa: "assets/icons/visa.svg",
        mastercard: "assets/icons/mastercard.svg",
        arrowleft: "assets/icons/arrowleft.svg",
        save: "assets/icons/save.svg",
        greaterthan: "assets/icons/greaterthan.svg",
        freedelivery: "assets/icons/freedelivery.svg",
        return: "assets/icons/return.svg",
        date: "assets/icons/date.svg",
        delete: "assets/icons/delete.svg",
        empty: "assets/icons/empty.svg",
        noproduct: "assets/icons/noproduct.svg",
        loginBox: "/assets/icons/box.svg",
        shield: "/assets/icons/shield.svg",
        lock: "/assets/icons/lock.svg",
        pencil: "/assets/icons/edit-pencil.svg",
        phone: "/assets/icons/phone.svg",
        email: "/assets/icons/email.svg",
        clock: "/assets/icons/clock.svg",
        twitter: "/assets/icons/twitter.svg",
        send: "/assets/icons/send.svg",
        minpurchase: "assets/icons/minpurchase.svg",
        cod: "assets/icons/cod.svg",
        onlinepay: "assets/icons/onlinepay.svg",
        tickmark:'assets/icons/tickmark.svg',
        rightarr:'assets/icons/rightarr.svg',
        truck:'assets/icons/truck.svg',
        refresh:'assets/icons/refresh.svg',
        bin:'assets/icons/bin.svg',
        secure:'assets/icons/secure.svg',
        starborder: 'assets/icons/starborder.svg',
        structure: 'assets/icons/structure.svg',
        account: 'assets/icons/account.svg',
        addprofile: 'assets/icons/addprofile.svg',
        orderaccount: 'assets/icons/orderaccount.svg',
        mail: 'assets/icons/mail.svg',
        newlogo: 'assets/icons/logo.svg',
        cake: 'assets/icons/cake.svg',
        editprofile: 'assets/icons/editprofile.svg',
        outlinecube: 'assets/icons/cubeoutline.svg',
        publish: 'assets/icons/publish.svg',
        heart: 'assets/icons/heart.svg',
        crowd: 'assets/icons/crowd.svg',
        light: 'assets/icons/light.svg',
        colorplate: 'assets/icons/colorplate.svg',
        gradutaion: 'assets/icons/degree.svg',
        handshake: 'assets/icons/handshake.svg',
        questionmark: 'assets/icons/questionmark.svg',
        circle: 'assets/icons/circle.svg',
        pointer: 'assets/icons/pointer.svg',
        deliver: 'assets/icons/deliver.svg',
        star: 'assets/icons/star.svg',
        teacher: 'assets/icons/teacher.svg',
        block: 'assets/icons/block.svg',
        buynow: 'assets/icons/buynow.svg',
        assemble: 'assets/icons/assemble.svg',
        dimension: 'assets/icons/dimension.svg',
        weight: 'assets/icons/weight.svg',
        flag: 'assets/icons/flag.svg',
        ideal: 'assets/icons/ideal.svg',
        view360: 'assets/icons/view360.svg',
        share: 'assets/icons/share.svg',
        tip: 'assets/icons/tip.svg',
        grandtotal: 'assets/icons/grandtotal.svg',
        mostused: 'assets/icons/mostused.svg',
        shapes: 'assets/icons/shapes.svg',
        coin: 'assets/icons/coin.svg',
        offer: 'assets/icons/offer.svg',
        noOrder: 'assets/icons/emptyOrder.svg',
        upload: 'assets/icons/upload.svg',
        box: 'assets/icons/box.svg',
        leave: 'assets/icons/leave.svg',
        sheilds: 'assets/icons/sheilds.svg',
        hand: 'assets/icons/hand.svg',
        authenticity: 'assets/icons/authenticity.svg',
        userdeletion: 'assets/icons/userdeletion.svg',
        privacy: 'assets/icons/privacy.svg',
        alert: 'assets/icons/alert.svg',
        database: 'assets/icons/database.svg',
        download: 'assets/icons/download.svg',
        users: 'assets/icons/users.svg',
        vehicle: 'assets/icons/vehicle.svg',
        creditcard: 'assets/icons/creditcard.svg',
        message: 'assets/icons/message.svg',
        chart: 'assets/icons/chart.svg',
        edit: 'assets/icons/edit.svg',
        store: 'assets/icons/store.svg',
        payment: 'assets/icons/payment.svg',
        fraud: 'assets/icons/fraud.svg',
        settings: 'assets/icons/settings.svg',
        platform: 'assets/icons/platform.svg',
        service: 'assets/icons/service.svg',
        bell: 'assets/icons/bells.svg',
        support: 'assets/icons/support.svg',
        dispute: 'assets/icons/dispute.svg',
        legal: 'assets/icons/legal.svg',
        enforcement: 'assets/icons/enforcement.svg',
        law: 'assets/icons/law.svg',
        filters:'assets/icons/filters.svg',
        warning:'assets/icons/warning.svg',
        building:'assets/icons/building.svg',
        map:'assets/icons/map.svg',
        userCheck:'assets/icons/userCheck.svg',
        power:'assets/icons/power.svg',
        penpaper:'assets/icons/penpaper.svg',
        headphone:'assets/icons/headphone.svg',
        gateway:'assets/icons/gateway.svg',
        passwordkey:'assets/icons/passwordkey.svg',
        otp: 'assets/icons/otp.svg',
        training: 'assets/icons/training.svg',
        authorizedaccess: 'assets/icons/authorizedaccess.svg',
        ssl: 'assets/icons/ssl.svg',
        communication: 'assets/icons/communication.svg',
        froudPrevent: 'assets/icons/froudPrevent.svg',
        whatsapp: "/assets/icons/whatsapp.svg",
        termcondition: 'assets/icons/termcondition.svg',
        privacypolicy: 'assets/icons/privacypolicy.svg',
        copyright: 'assets/icons/copyright.svg',
        trademark: 'assets/icons/trademark.svg',
        license: 'assets/icons/license.svg',
        registration: 'assets/icons/registration.svg',
        activity: 'assets/icons/activity.svg',
        price: 'assets/icons/price.svg',
        cancel: 'assets/icons/cancel.svg',
        hammer: 'assets/icons/hammer.svg',
        servicedescription: 'assets/icons/servicedescription.svg',
        disclaimer: 'assets/icons/disclaimer.svg',
        applicablelaw: 'assets/icons/applicablelaw.svg',
        despute: 'assets/icons/despute.svg',
        sitepolicy: 'assets/icons/sitepolicy.svg',
        bank: 'assets/icons/bank.svg',
        mobilePhone: 'assets/icons/mobilePhone.svg',
        doc: 'assets/icons/document.svg',
        openBox: 'assets/icons/openBox.svg',
  };

    iconRegistry = inject(MatIconRegistry);
    domSanitizer = inject(DomSanitizer);

    constructor() {}

    public registerIcons(): void {
        Object.keys(this.iconPaths).forEach((key) => {
            const iconPath = this.iconPaths[key];
            this.iconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath));
        });
    }
}
